import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n  align-self: center;\n  white-space: nowrap;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  height: 12px;\n  width: 12px;\n  padding-left: 10px;\n  path {\n    fill: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex: 1;\n  text-align: left;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  height: auto;\n  width: 15px;\n  margin-right: 15px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 22px;\n  margin: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n  margin: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Avenir Next';\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import { useHistory } from 'react-router-dom';
import styled from '../utils/styling/styled-components';
import { TOAST_NOTIFICATION } from '../utils/testing/TestIDs';
var CrumbContainer = styled.div(_templateObject(), function (props) {
  return props.theme.colors.white;
});
var Description = styled.div(_templateObject2());
var Title = styled.p(_templateObject3());
var Body = styled.p(_templateObject4());
var DisplayIcon = styled(AcornsIcon)(_templateObject5());
var TextContainer = styled.div(_templateObject6());
var RightArrow = styled(AcornsIcon)(_templateObject7(), function (props) {
  return props.theme.colors.white;
});
var Link = styled.div(_templateObject8());

var Crumb = function Crumb(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      body = _ref.body,
      link = _ref.link,
      linkText = _ref.linkText,
      testId = _ref.testId;
  var history = useHistory();

  var handleClick = function handleClick() {
    history.push(link, {
      referrer: history.location.pathname
    });
  };

  return /*#__PURE__*/React.createElement(CrumbContainer, {
    onClick: link && handleClick,
    "data-testid": testId || TOAST_NOTIFICATION
  }, /*#__PURE__*/React.createElement(DisplayIcon, {
    icon: icon || AcornsIcon.Icon.Checkmark
  }), /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(Description, null, title && /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(Body, null, body)), link && /*#__PURE__*/React.createElement(Link, null, linkText)), link && /*#__PURE__*/React.createElement(RightArrow, {
    icon: AcornsIcon.Icon.DisclosureRight
  }));
};

export { Crumb };